import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import LocationService from "../../services/LocationService";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import MessageDialog from "../../components/MessageDialog";

export default function AddLocation() {
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false); // NEW: edit mode loading
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // const messageTimer = useRef(null);
  const [editMode, setEditMode] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    if (id) {
      setEditMode(true);
      setIsEdit(id);
      fetchLocationById(id);
    } else {
      setValue("status", "Active");
    }
  }, [id]);

  const fetchLocationById = async (locationId) => {
    setEditLoading(true); // 🔄 START loading spinner for edit
    try {
      const res = await LocationService.getById(locationId);

      if (res?.data) {
        const record = res.data;

        setValue("locationName", record.locationName || "");
        setValue("locationCode", record.locationCode || "");
        setValue("fromKMS", record.fromKMS || "");
        setValue("toKMS", record.toKMS || "");
        setValue("status", record.status);
      } else {
        showMessage("Failed to load Location details.", "error");
      }
    } catch (error) {
      console.error(error);
      showMessage("Error fetching Location details.", "error");
    } finally {
      setEditLoading(false); // ✅ STOP loading spinner
    }
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      let res;

      if (isEdit && id) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await LocationService.update(id, data);
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        res = await LocationService.create({ ...data, status: "Active" });
      }

      console.log("Backend Response:", res);

      if (res?.status === true) {
        showMessage(
          isEdit
            ? "Location updated successfully."
            : "Location added successfully.",
          "success"
        );

        setTimeout(() => {
          localStorage.removeItem("editLocation");
          navigate("/cpnl/location/view");
        }, 800);

        return;
      }

      if (res?.message) {
        showMessage(res.message, "error");
        return;
      }

      showMessage("Failed to save Location.", "error");
    } catch (error) {
      console.error("Error saving location:", error);

      const msg =
        error.response?.data?.message ||
        error.message ||
        "Error saving location";

      showMessage(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    localStorage.removeItem("editLocation");
    navigate("/cpnl/location/view");
  };

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Location" : "Add Location"}
        secondTitle="Masters"
      ></Breadcrumb>

      {/* {message && (
        <div
          className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
            } d-flex justify-content-between align-items-center w-100 mb-3 p-2`}
          style={{ borderRadius: "5px" }}
        >
          <span>{message}</span>
          <button
            type="button"
            className="btn-close"
            onClick={closeMessage}
          ></button>
        </div>
      )} */}

        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
      

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading data...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <input type="hidden" {...register("status")} />
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Location Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Location Name"
                    {...register("locationName", {
                      required: "Location Name is required",
                    })}
                    disabled={loading}
                  />
                  {errors.locationName && (
                    <small className="text-danger">
                      {errors.locationName.message}
                    </small>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Location Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Location Code"
                    {...register("locationCode", {
                      required: "Location Code is required",
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                    disabled={loading}
                  />
                  {errors.locationCode && (
                    <small className="text-danger">
                      {errors.locationCode.message}
                    </small>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">From KMS/CH</label>
                  {/* <input
  type="number"
  step="0.001"
  className="form-control"
  {...register("fromKMS", {
    valueAsNumber: true,
    pattern: {
      value: /^\d+(\.\d{1,3})?$/,
      message: "Maximum 3 decimal places allowed",
    },
  })}
  disabled={loading}
/> */}
<input
  type="text"
  className="form-control"
  placeholder="Enter From KMS"
  {...register("fromKMS", {
    required: false,
    pattern: {
      value: /^\d+(\.\d{0,3})?$/,
      message: "Only 3 decimal values allowed",
    },
  })}
  onChange={(e) => {
    let value = e.target.value;

    // Allow only numbers + decimal
    if (!/^\d*\.?\d*$/.test(value)) return;

    // Restrict to 3 decimal places
    if (value.includes(".")) {
      const [intPart, decPart] = value.split(".");
      if (decPart.length > 3) {
        showMessage("Only 3 decimal values allowed", "error");
        return;
      }
    }

    setValue("fromKMS", value, { shouldValidate: true });
  }}
  onBlur={(e) => {
    let value = e.target.value;
    if (value !== "") {
      e.target.value = parseFloat(value).toFixed(3);
      setValue("fromKMS", e.target.value);
    }
  }}
  disabled={loading}
/>

{errors.fromKMS && (
  <small className="text-danger">{errors.fromKMS.message}</small>
)}
                </div>
                <div className="mb-3 col-md-6">
                  <label className="form-label">To KMS/CH</label>
                  {/* <input
  type="number"
  step="0.001"
  className="form-control"
  {...register("toKMS", {
    valueAsNumber: true,
    pattern: {
      value: /^\d+(\.\d{1,3})?$/,
      message: "Maximum 3 decimal places allowed",
    },
  })}
  disabled={loading}
/> */}

                    <input
  type="text"
  className="form-control"
  placeholder="Enter To KMS"
  {...register("toKMS", {
    required: false,
    pattern: {
      value: /^\d+(\.\d{0,3})?$/,
      message: "Only 3 decimal values allowed",
    },
  })}
  onChange={(e) => {
    let value = e.target.value;

    // Allow only numbers + decimal
    if (!/^\d*\.?\d*$/.test(value)) return;

    // Restrict to 3 decimal places
    if (value.includes(".")) {
      const [intPart, decPart] = value.split(".");
      if (decPart.length > 3) {
        showMessage("Only 3 decimal values allowed", "error");
        return;
      }
    }

    setValue("toKMS", value, { shouldValidate: true });
  }}
  onBlur={(e) => {
    let value = e.target.value;
    if (value !== "") {
      e.target.value = parseFloat(value).toFixed(3);
      setValue("toKMS", e.target.value);
    }
  }}
  disabled={loading}
/>

{errors.toKMS && (
  <small className="text-danger">{errors.toKMS.message}</small>
)}
                </div>
              </div>

              <div className="mt-3">
                <button
                  type="submit"
                  className="btn btn-primary me-2"
                  disabled={loading}
                >
                  <i className="ti ti-circle-check me-1"></i>
                  {loading ? "Saving..." : isEdit ? "Update" : "Save"}
                </button>
                <button
                  type="button"
                  onClick={handleCancel}
                  className="btn btn-secondary"
                  disabled={loading}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
